import React, { useEffect } from 'react'

export default function EmpEvaluation({ title, validate, Eva, onChangeTrigger, onChangeRating, index, totalShow, stateToSet }) {

    useEffect(() => {

    }, [validate])

    return (
        <>
            <div className="col-md-6 px-0 border-end">
                <h5 className="border border-end-0 border-start-0 border-top-0 tt-bold font-15 ps-4 py-4 mb-0">
                    {title}
                </h5>
                <div className="row ps-4 m-0 pt-3">
                    <div className="col-md-8">
                        <h6 className="font-12 bold-text pb-0">
                            Attitude <span className="required"> *</span>
                        </h6>
                    </div>
                    <div className="col-md-2 text-center">
                        <h6 className="font-12 bold-text text-blue">Rating <span>
                            <img src="/Images/help.svg" title="Ratings based on the total 
                            1. Does not Meet Expectations
                            2. Below Expectations
                            3. Meets Expectations
                            4. Sometimes Exceeding Expectations
                            5. Always Exceeding Expectation" alt="help-icon" />
                        </span></h6>
                    </div>
                    <div className="col-md-2 text-center">
                        <h6 className="font-12 bold-text text-blue text-blue">Total</h6>
                    </div>
                </div>
                <div className="row ps-4 m-0 pb-3">
                    <div className="col-md-8 align-self-center">
                        <textarea
                            name="description"
                            value={Eva[0].description}
                            onChange={(e) => {
                                onChangeTrigger(e, 0, Eva, stateToSet);
                            }}
                            className="form-control performance-textarea-sty"
                            id="exampleFormControlTextarea1"
                            placeholder="Enter Comments"
                            rows={3}
                        />
                        <span className='text-danger font-12 tt-bold'>
                            {validate[0]?.Validation}
                        </span>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <div className="d-flex">
                            <div className="d-block text-center align-self-center">
                                <p className="font-14 mb-0 bold-text text-blue">4 * </p>
                            </div>
                            <div className="d-block text-center align-self-center">
                                <select
                                    name="rating"
                                    value={Eva[0].rating}
                                    onChange={(e) => {
                                        onChangeRating(e, 0, Eva, stateToSet);
                                    }}
                                    className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                    aria-label="Default select example"
                                >
                                    <option value={0} selected> </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <p className="font-14 bold-text text-blue">
                            {Eva[0].total == 0 ? null : Eva[0].total}
                        </p>
                    </div>
                </div>
                <div className="row ps-4 m-0 pt-3 pb-3">
                    <label
                        htmlFor="exampleFormControlTextareae1"
                        className="form-label text-blue font-12 bold-text"
                    >
                        Communication<span className="required"> *</span>
                    </label>
                    <div className="col-md-8 align-self-center">
                        <textarea
                            value={Eva[1].description}
                            onChange={(e) => {
                                onChangeTrigger(e, 1, Eva, stateToSet);
                            }}
                            className="form-control performance-textarea-sty"
                            id="exampleFormControlTextareae2"
                            placeholder="Enter Comments"
                            rows={3}
                        />
                        <span className='text-danger font-12 tt-bold'>
                            {validate[1]?.Validation}
                        </span>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <div className="d-flex">
                            <div className="d-block text-center align-self-center">
                                <p className="font-14 mb-0 bold-text text-blue">3 * </p>
                            </div>
                            <div className="d-block text-center align-self-center">
                                <select
                                    value={Eva[1].rating}
                                    onChange={(e) => {
                                        onChangeRating(e, 1, Eva, stateToSet);
                                    }}
                                    className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                    aria-label="Default select example"
                                >
                                    <option value={0} selected> </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <p className="font-14 bold-text text-blue">
                            {Eva[1].total == 0 ? null : Eva[1].total}
                        </p>
                    </div>
                </div>
                <div className="row ps-4 m-0 pt-3 pb-3">
                    <label
                        htmlFor="exampleFormControlTextareae3"
                        className="form-label text-blue font-12 bold-text"
                    >
                        Business<span className="required"> *</span>
                    </label>
                    <div className="col-md-8 align-self-center">
                        <textarea
                            value={Eva[2]?.description}
                            onChange={(e) => {
                                onChangeTrigger(e, 2, Eva, stateToSet);
                            }}
                            className="form-control performance-textarea-sty"
                            id="exampleFormControlTextareae3"
                            placeholder="Enter Comments"
                            rows={3}
                        />
                        <span className='text-danger font-12 tt-bold'>
                            {validate[2]?.Validation}
                        </span>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <div className="d-flex">
                            <div className="d-block text-center align-self-center">
                                <p className="font-14 mb-0 bold-text text-blue">2 * </p>
                            </div>
                            <div className="d-block text-center align-self-center">
                                <select
                                    onChange={(e) => {
                                        onChangeRating(e, 2, Eva, stateToSet);
                                    }}
                                    className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                    aria-label="Default select example"
                                    value={Eva[2]?.rating}
                                >
                                    <option value={0} selected> </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <p className="font-14 bold-text text-blue">
                            {Eva[2].total == 0 ? null : Eva[2]?.total}
                        </p>
                    </div>
                </div>
                <div className="row ps-4 m-0 pt-3 pb-3">
                    <label
                        htmlFor="exampleFormControlTextareae4"
                        className="form-label text-blue font-12 bold-text"
                    >
                        Technology<span className="required"> *</span>
                    </label>
                    <div className="col-md-8 align-self-center">
                        <textarea
                            value={Eva[3]?.description}
                            onChange={(e) => {
                                onChangeTrigger(e, 3, Eva, stateToSet);
                            }}
                            className="form-control performance-textarea-sty"
                            id="exampleFormControlTextareae4"
                            placeholder="Enter Comments"
                            rows={3}
                        />
                        <span className='text-danger font-12 tt-bold'>
                            {validate[3]?.Validation}
                        </span>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <div className="d-flex">
                            <div className="d-block text-center align-self-center">
                                <p className="font-14 mb-0 bold-text text-blue">1 * </p>
                            </div>
                            <div className="d-block text-center align-self-center">
                                <select
                                    value={Eva[3]?.rating}
                                    onChange={(e) => {
                                        onChangeRating(e, 3, Eva, stateToSet);
                                    }}
                                    className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                    aria-label="Default select example"
                                >
                                    <option value={0} selected> </option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        <p className="font-14 bold-text text-blue">
                            {Eva[3].total == 0 ? null : Eva[3]?.total}
                        </p>
                    </div>
                </div>
                <div className="row ps-4 m-0 pt-3">
                    <div className="col-md-10 text-end align-self-center">
                        <p className="font-14 bold-text text-blue pe-4">Total</p>
                    </div>
                    <div className="col-md-2 text-center align-self-center">
                        {totalShow[index]?.grand_total == 0 ? (
                            <p className="font-14 bold-text text-blue">-</p>
                        ) : (
                            <p className="font-14 bold-text text-blue">

                                {totalShow[index]?.grand_total}
                            </p>
                        )}
                    </div>
                </div>
                <div className="row ps-4 m-0 pt-3">
                    <div className="col-md-10 text-end">
                        <p className="font-14 bold-text text-blue align-self-center pe-4">
                            Rating based on evaluation{' '}
                            <span>
                                <img src="/Images/help.svg" title="
                                                                            Ratings based on the total 
                                                                            44-50 = A+
                                                                            37-43 = A-
                                                                            30-36 = B+
                                                                            24-30 = B-
                                                                            17-23 = C+
                                                                            10-16 = C-"
                                    alt="help-icon" />
                            </span>
                        </p>
                    </div>
                    <div className="col-md-2 text-center px-2">
                        <p className="card-text tt-bold font-18 text-skyblue">
                            {totalShow[index]?.grand_rating ? <img

                                src={
                                    !totalShow[index]?.grand_rating
                                        ? null : totalShow[index]?.grand_rating.includes('+') ? `/Images/${totalShow[index]?.grand_rating?.slice(0, -1)}_plus.png`
                                            : totalShow[index]?.grand_rating.includes('-') ? `/Images/${totalShow[index]?.grand_rating?.slice(0, -1)}_minus.png` : null
                                }
                                className="emoji-sty  me-2" /> : null}
                            {totalShow[index]?.grand_rating}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
